import { createTheme } from '@mui/material/styles';
import { COLORS } from './colors';

const georgiaTypography = {
  fontFamily: 'Georgia',
  fontWeight: 'normal',
  fontStyle: 'normal',
};

const engraversGothicTypography = {
  fontFamily: 'Display sans',
  fontWeight: 'normal',
  fontStyle: 'normal',
};
const helveticaNeueTypography = {
  fontFamily: 'Helvetica Neue',
  fontWeight: 'normal',
  fontStyle: 'normal',
}

const ulineTypography = {
  fontFamily: 'AvantGardeGothic',
  fontWeight: 'normal',
  fontStyle: 'normal'
}

const drewTypography = {
  fontFamily: 'Times New Roman',
  fontWeight: 'normal',
  fontStyle: 'normal'
}
export const uiucTheme = createTheme({
  palette: {
    background: {
      default: COLORS.UIUCBlue,
    },
    primary: {
      main: COLORS.UIUCOrange,
    },
    secondary: {
      main: COLORS.UIUCBlue3,
    },
    text: {
      primary: COLORS.white,
      secondary: COLORS.black,
    },
  },
  typography: {
    ...georgiaTypography,
  }
});

export const jdTheme = createTheme({
  palette: {
    background: {
      default: COLORS.JDBlack,
    },
    primary: {
      main: COLORS.JDYellow,
    },
    secondary: {
      main: COLORS.JDGreen,
    },
    text: {
      primary: COLORS.black,
      secondary: COLORS.white,
    },
  },
  typography: {
    ...engraversGothicTypography
  }
});
export const cargillTheme = createTheme({
  palette: {
    background: {
      default: COLORS.black
    },
    primary: {
      main: COLORS.CargillGreen
    },
    secondary: {
      main: COLORS.white
    }
  },
  typography: {
    ...helveticaNeueTypography
  }
});

export const ulineTheme = createTheme({
  palette: {
    background: {
      default: COLORS.UlineBlue
    },
    primary: {
      main: COLORS.UlineRed
    },
    secondary: {
      main: COLORS.white
    }
  },
  typography: {
    ...ulineTypography
  },
});

export const drewTheme = createTheme({
  palette: {
    background: {
      default: COLORS.black
    },
    primary: {
      main: COLORS.JDGreen
    },
    secondary: {
      main: COLORS.white
    }
  },
  typography: {
    ...drewTypography
  }
});